'use client';

import { ReactNode, Ref, forwardRef, useEffect, useRef, useState } from "react";
import { Swiper as SwiperJS, SwiperProps, SwiperSlideProps } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { twMerge } from 'tailwind-merge';
import HomeArrow from '../../components/svg/HomeArrow';

interface Props {
  slides: ReactNode[];
  className?: string;
  wrapperClassName?: string;
  swiperProps?: Partial<SwiperProps>;
  swiperSlideProps?: Partial<SwiperSlideProps>;
}

const Swiper = ({ slides, className, wrapperClassName, swiperProps, swiperSlideProps }: Props) => {
  const [init, setInit] = useState(false);
  const [isBeginning, setIsBeginning] = useState(true);
    const [isEnd, setIsEnd] = useState(false);

    const ref = useRef<any>();
  return (
    <div className={twMerge('flex flex-col w-full h-full gap-y-[35px] desktop:gap-y-0 desktop:px-0 relative', wrapperClassName)}>
      <SwiperJS
        {...swiperProps}

        breakpoints={{
          0: {
            slidesPerView: 'auto',
            centeredSlides: false
          },
          768: {
            slidesPerView: 'auto',
            centeredSlides: false
          },
          1024: {
            slidesPerView: 'auto',
            enabled: false
          }
        }}
        onSlideChange={() => {
          const swiper = ref.current?.swiper;
          setIsBeginning(swiper.isBeginning);
          setIsEnd(swiper.isEnd);
        }}
        onInit={() => {
          const swiper = ref.current?.swiper;
          if (swiper) {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
            // swiper.autoplay.stop();
            // setTimeout(() => swiper.autoplay?.start(), 6000)
          }
          setInit(true);
        }}

        className={twMerge('w-full !relative', swiperProps?.className)}
        wrapperClass={twMerge(className)}
        ref={ref}
      >
        {slides.map((s, i) => <SwiperSlide key={i} {...swiperSlideProps} className={twMerge('pl-[24px] h-full', swiperSlideProps?.className)}>{s}</SwiperSlide>)}
      </SwiperJS>


         <div 
        onClick={() => {
          if (isEnd) return;
          ref.current?.swiper?.slideNext();
        }}
        className={twMerge(
          'absolute left-0 top-[40%] translate-y-[-50%] h-fit w-fit grid desktop:hidden place-items-center cursor-pointer z-10',
          isEnd && '!hidden'
        )}
      >
        <HomeArrow className='h-[48px] w-[48px] tablet:h-[72px] tablet:w-[72px]'/>
      </div>
      
      <div 
        onClick={() => {
          if (isBeginning) return;
          ref.current?.swiper?.slidePrev();
        }}
        className={twMerge(
          'absolute right-0 top-[40%] translate-y-[-50%] h-fit w-fit grid desktop:hidden place-items-center cursor-pointer rotate-180 z-10',
          isBeginning && '!hidden'
        )}
      >
        <HomeArrow className='h-[48px] w-[48px] tablet:h-[72px] tablet:w-[72px]'/>
      </div>
 </div>

)
};


export default Swiper;